import { baseUrl } from "./constants";

export const MarksFeedingEndpoints = {
    RaiseEditMarksRequest: `${baseUrl}/api/MarksFeeding/SendEditMarksRequest`,
    ExamHeadEditMarksNotification: `${baseUrl}/api/MarksFeeding/GetEditMarksRequestDetails`,
    ApproveEditMarksRequest: `${baseUrl}/api/MarksFeeding/ApproveEditMarksRequest`,
    UpdateMarksRequest: `${baseUrl}/api/MarksFeeding/UpdateMarksRequest`,
}

export const ReportCardEndpoints = {
    GetStudentDetailsForReportCard :  `${baseUrl}/api/PersonalDetails/StudentReportCardDetailsByStandardIdAndSectionId`,
    OverallAnnualExamReportByTeacherId :  `${baseUrl}/api/ResultReports/OverallAnnualExamReportByTeacherId`,
    CategoryWiseAnnualExamReportByTeacherId :  `${baseUrl}/api/ResultReports/CategorywiseAnnualExamReportByTeacherId`,
    SubjectAndTeacherwiseAnnualExamReportByTeacherId :  `${baseUrl}/api/ResultReports/SubjectAndTeacherwiseAnnualExamReportByTeacherId`,
}

export const SubjectCategoryMasterEndpoint = `${baseUrl}/api/SubjectCategoryMaster`;
export const SubjectCategoryConfigMasterEndpoint = `${baseUrl}/api/SubjectCategoryConfig`;

